import { Component, Input } from '@angular/core';
import { BaseGridComponent } from 'src/app/shared/components/base/base-grid.component';
import { CellClickedEvent, ColDef, ICellRendererParams } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { BusinessContextService } from 'src/app/core/services/domain/business-context.service';
import { Router } from '@angular/router';
import { MessageService } from 'src/app/core/services/domain/message.service';
import { MessageModel } from 'src/app/shared/models/domain/message.model';
import { InvoiceStatusesEnum } from 'src/app/shared/enums/domain/invoice-statuses.enum';
import { DialogService } from 'src/app/core/services/domain/dialog.service';

@Component({
  selector: 'app-messages-grid',
  templateUrl: './messages-grid.component.html',
  styleUrls: ['./messages-grid.component.scss']
})
export class MessagesGridComponent extends BaseGridComponent<MessageModel> {
  @Input() recipientClientKey = null;

  constructor(private businessContextService: BusinessContextService,
              private messageService: MessageService) {
    super();
    this.gridKey = 'Messages_v1';
  }

  protected setColumnDefinitions(): ColDef[] {
    return [
      {
        headerName: 'From',
        field: 'sender',
        hide: false,
        cellRenderer: function(params: ICellRendererParams): string {
          return params.data.sender.lastName + ', ' + params.data.sender.firstName;
        },
      },
      {
        headerName: 'To',
        field: 'recipient',
        hide: false,
        cellRenderer: function(params: ICellRendererParams): string {
          return params.data.recipient.lastName + ', ' + params.data.recipient.firstName;
        },
      },
      this.getDefaultColumn('subject', 'Subject'),
      this.getDateColumn('recipientReadDateTime', 'Read On'),
      this.getDateColumn( 'createdDateTime', 'Sent On')
    ];
  }

  protected onGridReady(): void {
    this.subscriptions.add(this.cellClick.subscribe((data: { data: MessageModel, event: CellClickedEvent }) => {
        this.rowClick.emit(data);
    }));
  }

  protected setRowData(): Observable<any[]> {
    return this.messageService.search({businessKey: this.businessContextService.currentBusiness.businessKey});
  }
}
